export const getFileId = (file: File) => `${file.lastModified}.${file.size}.${file.name}`;

export const getFileType = (fileName: string) => fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();